// src/components/AnimatedTitle.tsx
import { motion } from "framer-motion";
import { useLocation } from "react-router-dom";

interface AnimatedTitleProps {

}

export const AnimatedTitle: React.FC<AnimatedTitleProps> = () => {

 const { pathname } = useLocation()

    if (pathname == "/auth/login") {
        return (
            <motion.div
                className="relative w-[300px] space-y-2 "
                initial={{ scale: 0.9, opacity: 0 }}
                animate={{ scale: 1, opacity: 1 }}
                transition={{ delay: 0.3, duration: 0.3, ease: "easeOut" }}
                
            >
                <div className="text-3xl font-bold text-theam-blue-600">Join India’s Green Energy Revolution!</div>
                <div>Tokenize your renewable energy production and ensure every unit is verified, valued, and rewarded.</div>
            </motion.div>
        )
    }

      if (pathname == "/auth/signup") {
        return (
            <motion.div
                className="relative w-[300px] space-y-2 "
                initial={{ scale: 0.9, opacity: 0 }}
                animate={{ scale: 1, opacity: 1 }}
                transition={{ delay: 0.3, duration: 0.3, ease: "easeOut" }}
                
            >
                <div className="text-3xl font-bold text-theam-blue-600">Join India’s Green Energy Revolution!</div>
                <div>Tokenize your renewable energy production and ensure every unit is verified, valued, and rewarded.</div>
            </motion.div>
        )
    }


    return <></>

};